module.exports = __webpack_public_path__ + "img/memberWhite.91fe160e.svg";